// api
import { fetchApi } from '@/api'
// actions
const schoolroutesRoutesAll = (context) => {
  let url = 'schoolroutes/routes'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_ROUTES_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolroutesRoutesForm = (context) => {
  let url = 'schoolroutes/routes/create'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_ROUTES_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolroutesRoutesEdit = (context,data) => {
  let url = 'schoolroutes/routes/'+data.id+'/edit'
  return fetchApi(url, {}, 'GET')
    .then((response) => {
      console.log('data',response)
      context.commit('SCHOOLROUTES_ROUTES_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolroutesRoutesShow = (context) => {
  let url = 'schoolroutes/routes'
  let data = {}
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_ROUTES_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}
const schoolroutescrearRuta = (context, array) => {
  let url = 'schoolroutes/routes'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log("respooooonse",response)
      context.commit('SCHOOLROUTES_VEHICLES_LIST_CREAR', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolroutesAsignarAlumno = (context, array) => {
  let url = 'schoolroutes/asignarAlumno'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_VEHICLES_LIST_CREAR', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolroutesRoutesUpdate = (context,data) => {
  let url = 'schoolroutes/routes/'+data.id
  let json = JSON.stringify(data)
  return fetchApi(url, json, 'PUT')
    .then((response) => {
      context.commit('SCHOOLROUTES_ROUTES_UPDATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolroutesRoutesDelete = (context, payload) => {
  let url = 'schoolroutes/routes/'+payload.id
  return fetchApi(url, {}, 'DELETE')
    .then((response) => {
      context.commit('SCHOOLROUTES_ROUTES_DELETE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  schoolroutesRoutesAll,
  schoolroutesRoutesForm,
  schoolroutesRoutesShow,
  schoolroutescrearRuta,
  schoolroutesRoutesUpdate,
  schoolroutesRoutesDelete,
  schoolroutesRoutesEdit,
  schoolroutesAsignarAlumno
}



// WEBPACK FOOTER //
// ./src/store/modules/schoolroutes/routes/actions.js